import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const NetworkLandingPage = lazyWithChunkReload(() =>
  import("./network-landing").then((m) => ({ default: m.NetworkLanding }))
);
export const ConnectionsPage = lazyWithChunkReload(() =>
  import("./buyer/connections/components/connections.main").then((m) => ({
    default: m.ConnectionsPage,
  }))
);
export const ConnectionDetailPage = lazyWithChunkReload(() =>
  import("./buyer/connections/components/connection-detail.main").then((m) => ({
    default: m.ConnectionDetailPage,
  }))
);
export const ProductRequestsPage = lazyWithChunkReload(() =>
  import("./buyer/product-requests/components/product-requests.main").then((m) => ({
    default: m.ProductRequestsPage,
  }))
);
export const BuyerDetailsPage = lazyWithChunkReload(() =>
  import("./supplier/connections/components/buyer-details-page").then((m) => ({
    default: m.BuyerDetailsPage,
  }))
);
export const SupplierConnectionsPage = lazyWithChunkReload(() =>
  import("./supplier/connections/components/supplier-connections-page").then((m) => ({
    default: m.SupplierConnectionsPage,
  }))
);
export const BuyerProductRequestsOverviewPage = lazyWithChunkReload(() =>
  import("./supplier/connections/components/buyer-product-requests-overview-page").then((m) => ({
    default: m.BuyerProductRequestsOverviewPage,
  }))
);
